/**
 * Image compression utility using browser-image-compression
 * Ensures images don't exceed 2MB and 1600px max dimension
 */
import imageCompression from "browser-image-compression";

const MAX_SIZE_MB = 2;
const MAX_DIMENSION = 1600;

/**
 * Check if the file is an image that should be compressed
 */
export const isCompressibleImage = (file: File): boolean => {
  return (
    file.type === "image/jpeg" ||
    file.type === "image/jpg" ||
    file.type === "image/png" ||
    file.type === "image/webp"
  );
};

/**
 * Compresses an image file to ensure it doesn't exceed MAX_SIZE_MB
 * and MAX_DIMENSION for width/height
 * @param file The image file to compress
 * @returns Compressed file or original if compression not needed/possible
 */
export const compressImageFile = async (file: File): Promise<File> => {
  // Skip compression for non-images
  if (!isCompressibleImage(file)) {
    return file;
  }

  try {
    const compressedFile = await imageCompression(file, {
      maxSizeMB: MAX_SIZE_MB,
      maxWidthOrHeight: MAX_DIMENSION,
      useWebWorker: true,
      fileType: "image/jpeg", // Convert to JPEG for better compression
    });

    console.log(
      `Image compressed: ${file.name} - Original: ${(file.size / 1024 / 1024).toFixed(2)}MB -> Compressed: ${(compressedFile.size / 1024 / 1024).toFixed(2)}MB`,
    );

    return compressedFile;
  } catch (error) {
    console.error("Error compressing image:", error);
    // Return original file if compression fails
    return file;
  }
};
